var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo",staticStyle:{"float":"left"}},[_c('h1',[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("../../assets/images/logo.png"),"alt":"","width":"105px","height":"30px"}}),_vm._v(" "),_c('span',{staticClass:"line"},[_vm._v("|")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("高端智能设备一站式服务平台")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb92cd2a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/logo/Logo.vue
// module id = null
// module chunks = 